import React from 'react'

export const errorsMap = {
  validate: 'must be accepted',
  required: 'can\'t be blank',
  pattern: 'invalid format'
}

export const formTitleMap = {
  default: 'Contact us'
}

export const inputLabelsMap = {
  fullname: 'Name *',
  firstname: 'First name *',
  lastname: 'Last name *',
  company: 'Company name *',
  email: 'Email address *',
  phone: 'Business phone 34 456 656 678 *',
  message: 'Message *',
  accept_current_processing: <span>* I agree to the processing of my personal data provided above by Railwaymen Sp. z o.o. for direct contact and I accept <a className="link" href="https://railwaymen.org/docs/Railwaymen_PRIVACY_RULES.pdf">Privacy Policy</a>.</span>,
  accept_future_processing: <span>I agree to receive marketing communication from Railwaymen Sp. z o.o. (newsletter, information about services, promotions, or news).</span>
}